import distanceTokm from './DistanceToKm'

const createPlanName = (weeks, distance, level) => {
  return `trainingplan_${weeks}w_${distance}${level ? `_${level}` : ''}.csv`
}

export default createPlanName
